/**
 * Generates a task path for a given pull request global ID.
 * @param globalId - The global ID of the pull request.
 * @param sessionId - The ID of the session to be focused on page load.
 * @returns The task path URL, or an empty string if globalId is empty.
 */
export const generateTaskPath = (globalId: string, sessionId?: string) => {
  if (!globalId) {
    return ''
  }

  let taskPath = `/copilot/tasks/pull/${encodeURIComponent(globalId)}`
  if (sessionId) {
    taskPath += `?session_id=${encodeURIComponent(sessionId)}`
  }

  return taskPath
}
